<!--
 * @Description:
 * @Author: my2zzh <leo@easestrategy.com>
 * @Date: 2019-04-16 10:09:05
 * @LastEditTime: 2020-04-04 10:01:55
 * @LastEditors: my2zzh <leo@easestrategy.com>
 -->
<template>
  <div id="app" :class="{ gray: isGray }">
    <router-view />
  </div>
</template>

<script>
// import { browserRedirect } from '@/assets/js/browserRedirect'

export default {
  name: 'App',
  data() {
    return {
      jsonGray: false,
    };
  },
  created() {
    // browserRedirect(this.$route)
    fetch('/gray.json').then((data) => {
      data.json().then((res) => {
        this.jsonGray = res.isGray;
      });
    });
  },
  computed: {
    isGray() {
      return this.$route.name === 'Home' && this.jsonGray;
    },
  },
};
</script>

<style>
.gray {
  filter: grayscale(1);
  -webkit-filter: grayscale(1);
}
</style>



// WEBPACK FOOTER //
// src/App.vue